import axios from 'axios';
export default {
    name: 'SupervisorAlert',
    props: ['item', 'attendant'],
    data() {
        return {
            list: [],
            reason: ''
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //this.initialized = false;
            let suervisorUrl = APIURL + '/activity/attendantsalert/' + this.attendant.id;
            axios.post(suervisorUrl, this.item)
                .then(resp => {
                    this.list = resp.data;
                });
        },
        save() {
            if (this.reason == null ||
                this.reason.length == 0) {
                return;
            }
            let url = APIURL + '/activity/' + this.item.id + '/registerattendant';
            let activityPeriodAttendantMaps = [];
            if (this.item.activityPeriodId > 0) {
                activityPeriodAttendantMaps.push({ activityPeriodId: this.item.activityPeriodId, attendantId: this.attendant.id })
            }
            let data = [{
                id: this.attendant.id,
                isGroup: false,
                isApproved: true,
                activityPeriodAttendantMaps: activityPeriodAttendantMaps
            }];
            let saveAttenant = axios.put(url, data);

            let reasonurl = APIURL + '/activity/' + this.item.id + '/overridereason';
            let reasondata = [{
                applicationUserId: this.attendant.id,
                activityPeriodId: this.item.activityPeriodId,
                activityId: this.item.id,
                reason: this.reason,
                overrideType: 0,
                warning: this.attendant.name + '  heeft zich niet beschikbaar gesteld en heeft hier geen contractafspraak.'
            }]
            let saveReason = axios.put(reasonurl, reasondata);
            Promise.all([saveAttenant, saveReason])
                .then(() => {
                    window.location.reload(true);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        dismiss() {
            this.$vuedals.dismiss();
        }
    }
};